import { useContext, useState, useEffect } from "react";
import { ModalContext } from "../../../utils/modal/ModalProvider";
import { DialogEnum, showDialog } from "../../../utils/dialog/Dialog";
import { IAM_PATH, IAM_SERVER_SERVICE_USER, IAM_SERVER_SERVICE_GROUP, IAM_SERVER_SERVICE_ACOUNT } from "../../../utils/Config";
import Loading from "../../../utils/loading/Loading";
import axios from "../../../utils/api/axios";
import styles from "../../../utils/modal/DetailModal.module.css";
import { format } from "date-fns";
import { containsXss } from "../../../utils/security/XssFilter";
import AES, { encrypt } from "../../../utils/crypto/AES";
import { customAlphabet } from "nanoid";

export const GroupUserRegisterModal = ({ update, selectedServiceId, groupId, products }) => {
    const { closeModal } = useContext(ModalContext);
    const [loading, setLoading] = useState(true);
    const [serviceUserList, setServiceUserList] = useState([]);   // 전체 서비스 유저 [{userId, name}]
    const [groupUserList, setGroupUserList] = useState([]);       // 현재 그룹 유저 [{userId}]
    const [availableUsers, setAvailableUsers] = useState([]);     // 그룹에 미포함된 유저 [{userId, name}]
    const [assignedUsers, setAssignedUsers] = useState([]);       // 그룹에 포함된 유저 [{userId, name}]
    const [selectedAvailable, setSelectedAvailable] = useState([]);
    const [selectedAssigned, setSelectedAssigned] = useState([]);

    const today = new Date().toISOString().split('T')[0];
    // const futureDate = new Date(today);
    // futureDate.setMonth(futureDate.getMonth()+1);
    // futureDate.setDate(futureDate.getDate()-1);

    // const onemonth = futureDate.toISOString().split('T')[0];

    const [startDate, setStartDate] = useState(today);
    // const [endDate, setEndDate] = useState(onemonth);
    const [endDate, setEndDate] = useState(today);
    const [status, setStatus] = useState("deactive");
    const [isNull, setIsNull] = useState(false); //빈 값 확인

    const [formData, setFormData] = useState({
        groupId: groupId,
        email: '',
        password: '',
        product: '',
        plan: '',
        userName: '사용자',
        startDate: startDate,
        duration: '',
        endDate: endDate,
        status: status
    });

    // const [today] = useState({});
    const emailDomain = '@adduce.co.kr';
    useEffect(() => {
        setLoading(true);

        const nanoid = customAlphabet("0123456789abcdef", 10);
        formData.email = nanoid();

        setLoading(false);
    }, [selectedServiceId, groupId]);

    // 왼쪽 → 오른쪽 (그룹에 추가)
    const handleAssign = () => {
        const toAssign = availableUsers.filter(user =>
            selectedAvailable.includes(user.userId)
        );
        setAssignedUsers([...assignedUsers, ...toAssign]);
        setAvailableUsers(availableUsers.filter(user =>
            !selectedAvailable.includes(user.userId)
        ));
        setSelectedAvailable([]);
    };

    // 오른쪽 → 왼쪽 (그룹에서 제거)
    const handleUnassign = () => {
        const toUnassign = assignedUsers.filter(user =>
            selectedAssigned.includes(user.userId)
        );
        setAvailableUsers([...availableUsers, ...toUnassign]);
        setAssignedUsers(assignedUsers.filter(user =>
            !selectedAssigned.includes(user.userId)
        ));
        setSelectedAssigned([]);
    };

    // 체크박스 핸들러
    const handleCheckbox = (id, fromList) => {
        const setter = fromList === 'assigned' ? setSelectedAssigned : setSelectedAvailable;
        const current = fromList === 'assigned' ? selectedAssigned : selectedAvailable;
        setter(current.includes(id)
            ? current.filter(i => i !== id)
            : [...current, id]
        );
    };

    // 저장 로직
    const handleSave = () => {
        // 시작일: 00:00:00
        const startDate = new Date(`${formData.startDate}T00:00:00`);
        
        // 종료일: 23:59:59
        const endDate = new Date(`${formData.endDate}T23:59:59`);
        
        if (startDate > endDate) {
            alert("종료일은 시작일보다 뒤 날짜를 선택해야 합니다.");
        }

        for (let key in formData) {
            const value = formData[key];
            if (value === '') {
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            } else if (typeof value === 'string' && containsXss(value)) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }));
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }
        setIsNull(false);

        const pageParams = {
            groupId: formData.groupId,
            email: formData.email + emailDomain,
            password: encrypt(formData.password),
            product: formData.product,
            plan: formData.plan,
            userName: formData.userName,
            startDate: startDate.getTime(),
            endDate: endDate.getTime(),
            status: formData.status
        };

        setLoading(true);
        const url = IAM_PATH + IAM_SERVER_SERVICE_ACOUNT + "/create";
        axios.post(url, pageParams)
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                    update();
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const [duration, setDuration] = useState(''); // 일 수 (ex: "30", "60")

    const calculateEndDateByDuration = (startDateStr, months) => {
        const startDate = new Date(startDateStr);
        const nextMonth = new Date(startDate);
        nextMonth.setMonth(nextMonth.getMonth() + months);
        nextMonth.setDate(1);               // 다음 달 1일
        nextMonth.setDate(startDate.getDate() - 1); // 전날 → 사용기한 마지막 날

        const yyyy = nextMonth.getFullYear();
        const mm = String(nextMonth.getMonth() + 1).padStart(2, '0');
        const dd = String(nextMonth.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const handleStartDateChange = (e) => {
        const newStart = e.target.value;
        setStartDate(newStart);
        setFormData(prev => ({ ...prev, startDate: newStart }));

        if (duration) {
            const newEnd = calculateEndDateByDuration(newStart, parseInt(duration, 10));
            setEndDate(newEnd);
            setFormData(prev => ({ ...prev, endDate: newEnd }));
        }
    };

    const handleDurationChange = (e) => {
        formData.duration = e.target.value;
        const months = parseInt(e.target.value, 10);
        setDuration(e.target.value);

        if (formData.startDate && !isNaN(months)) {
            const newEnd = calculateEndDateByDuration(formData.startDate, months);
            setEndDate(newEnd);
            setFormData(prev => ({ ...prev, endDate: newEnd }));
        }
    };


    const handleStatusChange = (e) => {
        setStatus(e.target.value);
        formData.status = e.target.value;
    };

    // const [products, setProducts] = useState({products}); // 예: {"1": [...], "2": [...]}

    // 제품명 변경 핸들러
    const handleProductChange = (e) => {
        const selectedProductId = e.target.value;
        const plans = products[selectedProductId];

        setFormData(prev => ({
            ...prev,
            product: selectedProductId,
            plan: plans?.[0]?.plans || "" // 요금제 첫 항목 기본 선택
        }));
    };

    // 요금제 수동 변경 허용 시
    const handlePlanChange = (e) => {
        setFormData(prev => ({
            ...prev,
            plan: e.target.value
        }));
    };

    return (
        <div style={{ overflow: "auto" }}>
            {loading ? <Loading /> :
                <div>
                    <ul className={styles.layer__listWrap}>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>제품명</p>
                            <select
                                name="product"
                                className={styles.layer__listInput}
                                value={formData.product}
                                style={{ appearance: "auto" }}
                                onChange={handleProductChange}
                            >
                                <option value="">선택</option>
                                {Object.entries(products).map(([key, plans]) => (
                                    <option key={key} value={key}>
                                        {plans.name}
                                    </option>
                                ))}
                            </select>
                        </li>

                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>요금제</p>
                            <select
                                name="plan"
                                className={styles.layer__listInput}
                                value={formData.plan}
                                style={{ appearance: "auto" }}
                                onChange={handlePlanChange}
                            >
                                <option value="">선택</option>
                                {(products[formData.product]?.plans || []).map((p) => (
                                    <option key={p.id} value={p.id}>
                                        {p.plan}
                                    </option>
                                ))}
                            </select>
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>아이디</p>

                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"email"}
                                value={formData.email}
                                maxLength={63}
                                onChange={handleChange}
                            />
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"email"}
                                value={emailDomain}
                                readOnly={true}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>비밀번호</p>

                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"password"}
                                value={formData.password}
                                maxLength={20}
                                onChange={handleChange}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>사용자</p>

                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"userName"}
                                value={formData.userName || "사용자"}
                                maxLength={20}
                                onChange={handleChange}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>시작일</p>
                            <input className={styles.layer__listInput}
                                type={"date"}
                                name={"startDate"}
                                value={startDate}
                                onChange={handleStartDateChange}
                                onKeyDown={(e) => e.preventDefault()}
                                style={{ cursor: "pointer" }}
                            />
                        </li>
                        {/* <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>종료일</p>
                            <input className={styles.layer__listInput}
                                type={"date"}
                                name={"endDate"}
                                value={endDate}
                                onChange={handleEndDateChange}
                                onKeyDown={(e) => e.preventDefault()}
                                style={{ cursor: "pointer" }}
                                />
                        </li> */}
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>사용기한</p>
                            <select
                                className={styles.layer__listInput}
                                name="duration"
                                value={duration}
                                onChange={handleDurationChange}
                            >
                                <option value="">선택</option>
                                <option value="1">1개월</option>
                                <option value="2">2개월</option>
                                <option value="3">3개월</option>
                                <option value="4">4개월</option>
                                <option value="5">5개월</option>
                                <option value="6">6개월</option>
                                <option value="7">7개월</option>
                                <option value="8">8개월</option>
                                <option value="9">9개월</option>
                                <option value="10">10개월</option>
                                <option value="11">11개월</option>
                                <option value="12">12개월</option>
                            </select>
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>종료일</p>
                            <input
                                className={styles.layer__listInput}
                                type="date"
                                name="endDate"
                                value={endDate}
                                readOnly
                                style={{ backgroundColor: '#00000010', cursor: "default" }}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>상태</p>
                            <select name={"status"} className={styles.layer__listInput} value={status}
                                style={{ appearance: "auto" }}
                                onChange={handleStatusChange}>
                                <option value={"deactive"} defaultValue={true}>미할당</option>
                                <option value={"active"} >할당됨</option>
                                <option value={"expiration"}>만료</option>
                            </select>
                        </li>
                    </ul>

                    {/* {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null} */}
                    <div className={styles.layer__sensorBtnBox}>
                        {/* <button className={styles.layer__deleteBtn} onClick={"handleDelete"}>삭제</button> */}
                        <button className={styles.layer__modifyBtn} onClick={handleSave}>등록</button>
                    </div>
                </div>
            }
        </div>
    );
};
